import React from "react";
import { useNavigate } from "react-router-dom";
import { Bell, CheckCheck, Smartphone } from "lucide-react";
import { apiNotifikasi, apiBacaNotifikasi, apiBacaSemuaNotifikasi } from "@/lib/api";
import { lencana } from "@/lib/pushUtil";
import { KELAS_PANEL, KELAS_DAFTAR, KELAS_BARIS_JUDUL, KELAS_JUDUL, KELAS_ISI } from "@/lib/loncengPanel";
import * as W from "@/lib/waktu";

const waktu = (iso) => (iso ? W.waktu(iso) : "");

// G1-D: the owner's bell (polls every 30 s; push to the phone is separate).
// v2.19: `saya` = the bell of the Kasir/CS and the Manager (only what the server addressed to them).
export default function Lonceng({ saya = false }) {
  const navigate = useNavigate();
  const [d, setD] = React.useState({ belum_dibaca: 0, data: [] });
  const [open, setOpen] = React.useState(false);
  const ref = React.useRef(null);

  const load = React.useCallback(() => apiNotifikasi(saya).then(setD).catch(() => {}), [saya]);
  React.useEffect(() => {
    load();
    const id = setInterval(load, 30000);
    return () => clearInterval(id);
  }, [load]);
  React.useEffect(() => {
    if (!open) return undefined;
    const tutup = (e) => ref.current && !ref.current.contains(e.target) && setOpen(false);
    document.addEventListener("mousedown", tutup);
    return () => document.removeEventListener("mousedown", tutup);
  }, [open]);

  const buka = async (n) => {
    setOpen(false);
    if (!n.dibaca) await apiBacaNotifikasi(n.id, saya).catch(() => {});
    load();
    if (n.tautan) navigate(n.tautan);
  };

  return (
    <div className="relative" ref={ref}>
      <button type="button" data-testid="lonceng" aria-label="Notifikasi" onClick={() => { setOpen(!open); if (!open) load(); }}
        className="relative inline-flex items-center justify-center rounded-lg border border-slate-700 p-2 text-slate-300 hover:text-amber-300">
        <Bell size={16} />
        {d.belum_dibaca > 0 && (
          <span data-testid="lonceng-jumlah" className="absolute -top-1.5 -right-1.5 min-w-[1.1rem] rounded-full bg-red-600 px-1 text-[10px] font-bold leading-[1.1rem] text-white text-center">
            {lencana(d.belum_dibaca)}
          </span>
        )}
      </button>
      {open && (
        <div data-testid="lonceng-panel" className={KELAS_PANEL}>
          <div className="flex items-center justify-between px-3 py-2 border-b border-slate-800">
            <span className="text-[13px] font-semibold text-slate-200">Notifikasi</span>
            {d.belum_dibaca > 0 && (
              <button type="button" data-testid="lonceng-baca-semua" onClick={() => apiBacaSemuaNotifikasi(saya).then(load)}
                className="inline-flex items-center gap-1 text-xs text-cyan-300"><CheckCheck size={12} /> Tandai semua dibaca</button>
            )}
          </div>
          <div className={KELAS_DAFTAR}>
            {d.data.length === 0 && <p className="px-3 py-4 text-sm text-slate-500">Belum ada notifikasi.</p>}
            {d.data.map((n) => (
              <button key={n.id} type="button" onClick={() => buka(n)} data-testid={`notif-${n.jenis}`}
                className={`w-full text-left px-3 py-2 hover:bg-slate-900 ${n.dibaca ? "opacity-60" : ""}`}>
                <div className={KELAS_BARIS_JUDUL}>
                  {!n.dibaca && <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-amber-400 sm:mt-0" />}
                  <span className={KELAS_JUDUL}>{n.judul}</span>
                  {n.push && <Smartphone size={11} className="mt-1 shrink-0 text-slate-500 sm:mt-0" title="Juga dikirim ke HP" />}
                </div>
                <div className={KELAS_ISI}>{n.isi}</div>
                <div className="text-[10px] font-mono text-slate-600">{waktu(n.waktu)}</div>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
